<template>
  <!--
    Tenant lifecycle — the persistent past-due banner on every /my/* page and
    the customer dashboard. Everything still works; this only says when the
    lock will happen and where to pay. Text and date come from
    utils/org-lifecycle.js pastDueBanner(), so the wording is unit-tested.
    Not dismissible: it is the one warning before the organisation stops.
  -->
  <div
    v-if="banner"
    class="olb"
    role="status"
    aria-live="polite"
  >
    <div class="olb-inner">
      <i class="fas fa-clock olb-icon" aria-hidden="true"/>
      <p class="olb-text">{{ banner.text }}</p>
      <router-link :to="banner.linkTo" class="olb-link">{{ banner.linkLabel }}</router-link>
    </div>
  </div>
</template>

<script>
import { pastDueBanner, isBannerRoute } from '@/utils/org-lifecycle'

export default {
  name: 'OrgLifecycleBanner',
  computed: {
    banner() {
      if (!this.$store.state.auth?.isAuthenticated) return null
      if (!isBannerRoute(this.$route?.path)) return null
      return pastDueBanner(this.$store.getters['auth/currentUser'])
    }
  }
}
</script>

<style scoped>
.olb {
  /* First child of <main>, whose padding already clears the fixed navbar. */
  position: relative;
  z-index: 5;
  background: #fffbeb;
  border-bottom: 1px solid #fcd34d;
  border-left: 4px solid var(--ds-warning, #f59e0b);
}
.olb-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0.65rem 16px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.olb-icon {
  color: #b45309;
  flex: none;
}
.olb-text {
  margin: 0;
  flex: 1 1 16rem;
  min-width: 0;
  color: #78350f;
  font-family: var(--ds-font-body);
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.4;
}
.olb-link {
  flex: none;
  padding: 0.4rem 0.9rem;
  border-radius: var(--ds-radius-md, 8px);
  background: #b45309;
  color: var(--ds-white, #fff);
  font-weight: 600;
  font-size: 0.88rem;
  text-decoration: none;
}
.olb-link:hover { background: #92400e; }
.olb-link:focus-visible {
  outline: 2px solid var(--ds-primary-500, #1a7fd4);
  outline-offset: 2px;
}
</style>
